import { faArrowRight, faEye, faEyeSlash, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect } from 'react'
import { SERVER_URL } from '../../config';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import GoogleTranslate from '../../GoogleTranslate';

export default function PlayerLogin() {

  const [showPassword, setShowPassword] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [isLogin, setIsLogin] = useState(false);

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const playerToken = sessionStorage.getItem('player_token');

  useEffect(() => {
    let decoded;
    const isValid = (token) => {
      if (!token) return false;
      try {
        decoded = jwtDecode(token);
        return decoded.exp * 1000 > Date.now();
      } catch {
        return false;
      }
    };
    console.log(decoded, isValid)
    if (isValid(playerToken)) {
      navigate('/user/dashboard');
    }
  }, [playerToken]);

  const handleSubmit = async () => {
    try {
      const newErrors = {};

      if (!email.trim()) {
        newErrors.email = "Email is required";
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) newErrors.email = "Invalid email format";
      }

      if (!password) {
        newErrors.password = "Password is required";
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }
      setErrors({});
      setIsLogin(true)
      const response = await axios.get(`${SERVER_URL}/api/v2/player-login?email=${email}&password=${password}`);
      if (response.data.status === true) {
        toast.success("Login successfully!");
        sessionStorage.setItem('player_token', response.data._token);
        checkProfile(response.data._token);
        navigate("/?source=player")
      } else if (response.data.status === false) {
        toast.error("Invalid credentials")
      }
    } catch (error) {
      console.error("Error during Login : ", error);
      toast.error(error.response?.data?.msg ? error?.response?.data?.msg : "Failed to Login. Please try again.");
    } finally {
      setIsLogin(false)
    }
  };

  const checkProfile = async (token) => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/v2/player-profile-check`, {
        headers: { Authorization: `Bearer ${token}`, }
      });
      // if (response.data.status === true && response.data.msg === 'updated') {
      //   setTimeout(() => {
      //     navigate("/user/dashboard")
      //   }, 1500);
      // } else {
      // setTimeout(() => {
      //   navigate("/")
      // }, 1500);
      // }
    } catch (error) {
      console.error("Error checking the player profile : ", error);
    }
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  return (
    <div className='lg:h-screen flex flex-col items-center justify-center bg-cover pt-10 lg:pt-0 overflow-hidden' style={{ backgroundImage: 'url("/assets/bg/Authbg.svg")' }}>
      <div className='flex justify-between w-full md:mb-0 mb-10'>
        <div className='w-[50%]'>
          <button onClick={() => { window.location.href = '/' }} className=" cursor-pointer absolute top-5 left-5 flex items-center gap-2 text-white px-4 py-2 rounded-full">
            <FontAwesomeIcon icon={faArrowLeft} />
            <span >Back</span>
          </button>
        </div>

        <div className='top-5 right-1 absolute'>
          <GoogleTranslate />

        </div>
      </div>

      <div className='w-[90%] flex flex-col-reverse lg:flex-row items-center gap-10'>
        <div className='w-[100%] lg:w-[50%] relative'>
          <img src='/assets/others/herologin.svg' className='md:w-[75%] mx-auto' data-aos='fade-right' data-aos-duration='1500'></img>
          <img src='/assets/others/Ball.svg' className='ball-spin w-[25%] absolute bottom-10 right-0 lg:hidden block' style={{ zIndex: 1 }} />
        </div>
        <div className='w-[100%] lg:w-[50%] text-white relative'>
          <div className='bg-white/5 lg:w-[90%] 2xl:w-[80%] 2xl:mx-auto p-7 lg:px-10 py-10 lg:py-20 2xl:py-24 brand-fade-2'>
            <h1 className='text-center text-3xl md:text-5xl 2xl:text-6xl' style={{ fontFamily: 'Sacramento' }}>Login</h1>
            <div className='w-[100%] md:w-[90%] mx-auto mt-5'>
              <label className='font-semibold text-lg'>Email</label>
              <input
                type="email"
                onChange={(e) => {
                  const value = e.target.value;
                  setEmail(value);

                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  setErrors((prev) => ({
                    ...prev,
                    email: value && !emailRegex.test(value.trim())
                      ? "Invalid email format"
                      : "",
                  }));
                }}
                required
                className='w-[100%] mt-1 border rounded outline-none py-2 px-3'
              />
              {errors.email && <p className="text-red-400 text-sm">{errors.email}</p>}

            </div>
            <div className='w-[100%] md:w-[90%] mx-auto mt-5'>
              <div className='flex items-center justify-between'>
                <label className='font-semibold text-lg'>Password</label>
                <a onClick={() => { navigate('/forget-password?role=players') }} className='cursor-pointer font-semibold text-sm'>Forget Password ?</a>
              </div>
              <div className='relative mt-1'>
                <input type={showPassword ? 'text' : 'password'} onChange={(e) => { setPassword(e.target.value) }}
                  className='w-[100%] border rounded outline-none py-2 px-3'
                />
                <button
                  type='button'
                  onClick={togglePasswordVisibility}
                  className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'
                >
                  <FontAwesomeIcon
                    icon={showPassword ? faEye : faEyeSlash}
                    className='text-gray-500'
                  />
                </button>
                {errors.password && <p className="text-red-400 text-sm">{errors.password}</p>}

              </div>
            </div>
            <div className='flex justify-center mt-5'>
              <button onClick={handleSubmit} className='border rounded-full flex items-center gap-2 py-[2px] pl-5 pr-[2px] cursor-pointer'>
                <span>Sign in </span>
                <button className='w-8 h-8 rounded-full bg-white text-black grid place-content-center'>
                  {isLogin ? (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  ) : (
                    <FontAwesomeIcon icon={faArrowRight} />
                  )}
                </button>
              </button>
            </div>
            <p className='font-semibold text-center mt-5'>Need Help With Login ? Support</p>
            <p className="font-semibold text-center mt-5">
              <span onClick={() => navigate("/player/signup")} className=" cursor-pointer hover:underline">
                Create account
              </span>
            </p>
          </div>
          <div data-aos='fade-right' data-aos-duration='1500'>
            <img src='/assets/others/Ball.svg' className='ball-spin absolute -bottom-10 right-3 hidden lg:block' style={{ zIndex: 1 }} />
          </div>
        </div>
      </div>
    </div>
  )
}
